import {
  FETCH_PROGRAM_SETUPS,
  FETCH_BOUND_TASKS,
  FETCH_BOUND_USERS,
  PROGRAM_SETUP_VALIDATION_ERROR,
  UNBIND_TASK,
  UNBIND_USER,
  UPDATE_PROGRAM_SETUP_SUCCESS,
  DETACH_PROGRAM_SETUP_SUCCESS,
  PROGRAM_SETUP_GET_SUCCESS,
  PROGRAM_SETUP_CATEGORIES_REQUEST, 
  PROGRAM_SETUP_CATEGORIES_REDIRECT 
} from "../actions/ActionTypes";

const initialState = {
  program_setups: [],
  bound_tasks: [],
  bound_users: [],
  programSetupRecord: null,
  showSetupForm: false,
  validation_errors: null,
  is_loading: false,
};

const ProgramSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROGRAM_SETUP_CATEGORIES_REQUEST:
          return { ...state, is_loading: true, redirectToList: false, validation_error: "" };
    case FETCH_PROGRAM_SETUPS: 
      return {
        ...state,
        program_setups: action.payload,
        is_loading: false,
      };
    case PROGRAM_SETUP_GET_SUCCESS:
      return {
        ...state,
        is_loading: false,
        programSetupRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showSetupForm: action.actionType === 'setup',
      };
    case PROGRAM_SETUP_CATEGORIES_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showSetupForm: false,
        programSetupRecord: null,
        formState: {},
        validation_error: ""
      };
    case UPDATE_PROGRAM_SETUP_SUCCESS:
      return {
        ...state,
        is_loading: false,
      };
    case DETACH_PROGRAM_SETUP_SUCCESS:
      return {
        ...state,
        is_loading: false,
      };
    case FETCH_BOUND_TASKS:
      return {
        ...state,
        bound_tasks: action.payload,
        is_loading: false,
      };
    case FETCH_BOUND_USERS:
      return {
        ...state,
        bound_users: action.payload,
        is_loading: false,
      };
    case UNBIND_TASK:
      return {
        ...state,
        bound_tasks: state.bound_tasks.filter(
          (task) => task.id !== action.payload
        ),
      };
    case UNBIND_USER:
      return {
        ...state,
        bound_users: state.bound_users.filter(
          (user) => user.id !== action.payload
        ),
      };
    case PROGRAM_SETUP_VALIDATION_ERROR:
      return {
        ...state,
        validation_errors: action.payload,
        is_loading: false,
      };
    default:
      return state;
  }
};

export default ProgramSetupReducer;
